import api from '../baseApi';
import { Design, DesignsListResult, DesignCategory } from '../typings/designs';

export const listDesigns = async (
    from: number,
    count: number,
    search?: string,
    sortBy?: string,
    sortMode?: string,
    fromUser?: boolean,
    deleted = false
): Promise<DesignsListResult> => {
    const response = await api.get('/Admin/Designs', {
        params: {
            from,
            count,
            search,
            sortBy,
            sortMode,
            byAdmin: !fromUser,
            deleted
        }
    });
    return response.data;
};

export const getDesign = async (id: string): Promise<Design> => {
    const response = await api.get(`/Admin/Designs/${id}`);
    return response.data;
};

export const saveDesign = async (designTemplate: Design, id?: string): Promise<Design> => {
    const url = id ? `/Admin/Designs/${id}` : '/Admin/Designs';
    const response = await api.put(url, designTemplate);
    return response.data;
};

export const updateDesign = async (designTemplate: Design, id: string): Promise<Design> => {
    const url = `/Admin/Designs/${id}/Update`;
    const response = await api.put(url, designTemplate);
    return response.data;
};

export const cloneDesign = async (id: string): Promise<Design> => {
    const response = await api.post(`/Admin/Designs/${id}/Clone`);
    return response.data;
};

export const cloneDesignAndDependencies = async (id: string): Promise<Design> =>
    api.post<Design>(`/Admin/Designs/${id}/CloneWithDependencies`).then(({ data }) => data);

export const deleteDesign = async (id: string): Promise<Design> => {
    const response = await api.delete(`/Admin/Designs/${id}`);
    return response.data;
};

export const softDeleteDesign = async (id: string): Promise<void> => {
    await api.put(`/Admin/Designs/${id}/Delete`);
};

export const restoreSoftDeletedDesign = async (id: string): Promise<void> => {
    await api.put(`/Admin/Designs/${id}/Restore`);
};

export const getDesignCategories = (): Promise<DesignCategory[]> =>
    api.get<DesignCategory[]>(`/DesignCategory`).then(({ data }) => data);

export const importDesignFromAdmin = async (
    id: string
): Promise<{
    newDesignId: string;
}> => {
    const response = await api.post(`/MyDesigns/${id}/Import`);
    return response.data;
};

export const exportDesign = async (id: string): Promise<string> =>
    api.get<string>(`/Admin/Designs/${id}/ExportUrl`).then(({ data }) => data);
